export {wrapRootElement} from './gatsby-wrapper';

import {createLandingAnalytics} from '../core/visitorAnalytics/landingAnalytics';
import configs from './analyticsConfig.gen.json';

export const onRouteUpdate = createLandingAnalytics(configs);
